import { GraphQLResult } from "@aws-amplify/api-graphql";
import { API, graphqlOperation } from "aws-amplify";
import { createSubject, deleteSubject, updateSubject } from "graphql/mutations";
import {
  getSubject,
  listSubjectSortByExpirationDate,
  listSubjectSortBySeq,
} from "graphql/queries";
import {
  CreateSubjectInput,
  DeleteSubjectInput,
  GetSubjectQuery,
  ListSubjectSortByExpirationDateQuery,
  ListSubjectSortBySeqQuery,
  ModelSortDirection,
  Subject,
  UpdateSubjectInput,
} from "types/graphqlapi";
import { listGroupsQuery } from "utils/apis/group";
import { getYMDStr } from "utils/common";

export const getSubjectQuery = async (
  subjectId: string
): Promise<Subject | undefined> => {
  try {
    const result = (await API.graphql(
      graphqlOperation(getSubject, {
        id: subjectId,
      })
    )) as {
      data: GetSubjectQuery;
    };

    // 削除データの排除
    return result?.data?.getSubject as Subject;
  } catch (e) {
    // TODO エラーハンドリング
    console.error(e);
    throw e;
  }
};

export const listAllSubjectsQuery = async (): Promise<
  Subject[] | undefined
> => {
  try {
    let list: Subject[] = [];
    const groups = await listGroupsQuery();
    if (groups) {
      for (const group of groups) {
        const result = (await API.graphql(
          graphqlOperation(listSubjectSortByExpirationDate, {
            group_id: group.id,
            expiration_date: {
              ge: getYMDStr(new Date()),
            },
            limit: 10000,
          })
        )) as {
          data: ListSubjectSortByExpirationDateQuery;
        };

        const items = (result?.data?.listSubjectSortByExpirationDate?.items ||
          []) as Subject[];

        // SEQの降順
        items.sort((a, b) => {
          if (a.subject_seq < b.subject_seq) return -1;
          if (a.subject_seq > b.subject_seq) return 1;
          return 0;
        });

        list = [...list, ...items];
      }
    }

    return list;
  } catch (e) {
    // TODO エラーハンドリング
    console.error(e);
    throw e;
  }
};

export const listSubjectsQuery = async (
  groupId: string
): Promise<Subject[] | undefined> => {
  try {
    const endDateCond = new Date();
    endDateCond.setMonth(endDateCond.getMonth() - 1);

    const result = (await API.graphql(
      graphqlOperation(listSubjectSortByExpirationDate, {
        group_id: groupId,
        expiration_date: {
          ge: getYMDStr(new Date()),
        },
        limit: 10000,
      })
    )) as {
      data: ListSubjectSortByExpirationDateQuery;
    };

    // 削除データの排除
    const list = result?.data?.listSubjectSortByExpirationDate
      ?.items as Subject[];

    // SEQの降順
    list.sort((a, b) => {
      if (a.subject_seq < b.subject_seq) return -1;
      if (a.subject_seq > b.subject_seq) return 1;
      return 0;
    });

    return list;
  } catch (e) {
    // TODO エラーハンドリング
    console.error(e);
    throw e;
  }
};
export const createSubjectMutation = async (
  createSubjectInput: CreateSubjectInput
): Promise<string | undefined> => {
  try {
    // SEQMAX取得して設定する。
    const resultSeq = (await API.graphql(
      graphqlOperation(listSubjectSortBySeq, {
        group_id: createSubjectInput.group_id,
        sortDirection: ModelSortDirection.DESC,
        limit: 1,
      })
    )) as {
      data: ListSubjectSortBySeqQuery;
    };

    createSubjectInput.subject_seq = resultSeq.data.listSubjectSortBySeq?.items
      ? resultSeq.data.listSubjectSortBySeq.items[0]
        ? resultSeq.data.listSubjectSortBySeq.items[0].subject_seq + 1
        : 1
      : 1;

    const createdSubject = (await API.graphql(
      graphqlOperation(createSubject, { input: createSubjectInput })
    )) as GraphQLResult<{
      createSubject: Subject;
    }>;

    // END_CLIENTは初期作成０件
    // for (const i in seqList) {
    //   const batchCreateMasterAuthenticatorInput6: BatchCreateMasterAuthenticatorInput =
    //     {
    //       subject_id: createdSubject.data?.createSubject?.id
    //         ? createdSubject.data?.createSubject?.id
    //         : "",
    //       sort_index: seqList[i].seq + 13,
    //       pin_code: makePinCode(),
    //       interview_role: InterviewRoleType.END_CLIENT,
    //     };
    //   batchCreateMasterAuthenticatorInputs.push(
    //     batchCreateMasterAuthenticatorInput6
    //   );
    // }

    return createdSubject.data?.createSubject.id;
  } catch (e) {
    // TODO エラーハンドリング
    console.error(e);
    throw e;
  }
};

export const updateSubjectMutation = async (
  updateSubjectInput: UpdateSubjectInput
) => {
  try {
    return await API.graphql(
      graphqlOperation(updateSubject, { input: updateSubjectInput })
    );
  } catch (e) {
    // TODO エラーハンドリング
    console.error(e);
    throw e;
  }
};

export const deleteSubjectMutation = async (
  deleteSubjectInput: DeleteSubjectInput
) => {
  try {
    await API.graphql(
      graphqlOperation(deleteSubject, { input: deleteSubjectInput })
    );
  } catch (e) {
    // TODO エラーハンドリング
    console.error(e);
    throw e;
  }
};
